'use strict';

// splash  = require('../../components/splash'),

var coreManager = null,
    homeKey = 27,
    taskManager = null,
    intentManager = null,
    platformKeydownEventHandler = null,
    preventDefaultKeys = null;


if ( PLATFORM === 'TIZEN' ) {
    homeKey = 10182;
}

if ( PLATFORM === 'SMARTTV' ) {
    homeKey = (new window.top.Common.API.TVKeyValue()).KEY_EXIT;
    preventDefaultKeys = [
        'keydown:' + (new window.top.Common.API.TVKeyValue()).KEY_EXIT,
        'keydown:' + (new window.top.Common.API.TVKeyValue()).KEY_RETURN,
        'keydown:' + (new window.top.Common.API.TVKeyValue()).KEY_TOOLS
    ];
}


if ( PLATFORM === 'WEBOS' ) {
    // home not available at this platform so we use back key code
    homeKey = 461;
}


module.exports = function ( eventName, eventData )  {
    var api = require('./api'),
        index, size, appCore;

    if ( coreManager === null ) {
        coreManager = require('../kernel/core.manager');
    }
    if ( taskManager === null ) {
        taskManager  = require('./task.manager');
    }
    if ( intentManager === null ) {
        intentManager  = require('./intent.manager');
    }

    if ( preventDefaultKeys !== null ) {
        if ( taskManager.focusedApp ) {
            if ( preventDefaultKeys.indexOf(eventName) !== -1 ) {
                eventData.preventDefault();
            }
        }
    }

    if ( homeKey !== null && eventName === 'keydown:' + homeKey ) {
        if ( PLATFORM === 'TIZEN' ) {
            api.exit();

            return;
        }

        if ( PLATFORM === 'MAG' || NANOCORE ) {
            require('./system').emit('home');
            taskManager.hideAll();

            // if ( MODE === 'PORTAL' ) {
            //     if ( !taskManager.launcher || (taskManager.launcher && taskManager.launcher.$iframe.isVisible) ) {
            //         /* eslint no-undef: 0 */
            //         api.exit();
            //     }
            // }
        } else {
            if ( !taskManager.launcher || (taskManager.launcher && taskManager.launcher.$iframe.isVisible) ) {
                /* eslint no-undef: 0 */
                if ( PLATFORM !== 'WEBOS' ) {
                    api.exit();
                }
            }

            if ( PLATFORM !== 'WEBOS' ) {
                require('./system').emit('home');
                taskManager.hideAll();
            }

            return;
        }
    }

    index = 0;
    size = coreManager.coreList.length;

    while ( index < size ) {
        if ( DEVELOP ) {
            window.cm = coreManager;
        }

        appCore = coreManager.coreList[index];
        if ( appCore && appCore.system ) {
            if ( appCore.events[eventName] ) {
                appCore.emit(eventName, eventData);
            }
        }
        ++index;
    }

    if ( platformKeydownEventHandler === null ) {
        platformKeydownEventHandler = require('./platform.event').keydown;
    }

    if ( typeof platformKeydownEventHandler === 'function' ) {
        platformKeydownEventHandler(eventName, eventData);
    }
};
